import * as yup from 'yup';

export const CreatePayrollValidationSchema = yup.object().shape({
    payrollName: yup.string().required('Payroll name is required').max(100, 'Payroll name must not exceed 100 characters'),
    payrollType: yup.number().typeError('Payroll type is required').required('Payroll type is required'),
    payrollUrl: yup.string().url('Please enter a valid URL').required('Payroll URL is required'),
    authenticationType: yup.number().typeError('Authentication type is required').required('Authentication type is required'),
    username: yup.string().when('authenticationType', {
        is: 2,
        then: yup.string().required('Username is required'),
        otherwise: yup.string().nullable()
    }),
    password: yup.string().when('authenticationType', {
        is: 2,
        then: yup.string().required('Password is required'),
        otherwise: yup.string().nullable()
    }),
    authToken: yup.string().required('Auth token is required')
});
